<template>
  <div class="form-group">
    <div class="col-form-label col-12 col-md-3" :class="labelClass">
      <label :for="id" class="text-truncate" v-text="label" />
    </div>
    <div class="col-12 col-md-9 py-0">
      <div class="row">
        <div class="col-12 mb-1 mb-md-n1 col-md py-0">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import uniqid from "uniqid";

export default {
  props: {
    id: {
      type: String,
      default: () => uniqid("FormGroup-")
    },
    label: {
      type: String,
      default: ""
    },
    labelClass: {
      type: String,
      default: ""
    }
  }
};
</script>
